import { render, staticRenderFns } from "./SectionNavigationHorizontal.vue?vue&type=template&id=6fef631c&"
import script from "./SectionNavigationHorizontal.vue?vue&type=script&lang=ts&"
export * from "./SectionNavigationHorizontal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports